import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const checkSpecialDocumentTypeWithDocTitleExistRule: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
	const documentType = control.get('documentType')!.value;
	const documentTitle = control.get('documentTitle')!.value;
	const documentCategory = control.get('documentCategory')!.value;
	const documentTypeArray = ['EGD011', 'EGD016', 'EGD026','EGD027'];

	return documentTypeArray.includes(documentType) && documentCategory !== 'EGD02' && !documentTitle ?
	      { checkSpecialDocumentTypeWithDocTitleExistFlag: true } : null;
};
